import axios from 'axios';
import { ContactFormPayload } from '../../../types';

const BACKEND_BASE_URL = process.env.REACT_APP_API_BASE_URL;

if (!BACKEND_BASE_URL) {
  throw new Error('REACT_APP_API_BASE_URL is not defined');
}

export const submitContactForm = async (data: ContactFormPayload): Promise<void> => {
  await axios.post(`${BACKEND_BASE_URL}/glassix/biamba/contact-form`, data);
};
